const commons = {};

commons.bizSerialFormatter = (num) => {
  let formatNum = num;

  if (!!num && num.length === 10) {
    formatNum = num.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
  }

  return formatNum;
};

export default commons;
